<!--
 * @Author: 陈红伟 chenhw2019@gmail.com
 * @Date: 2024-01-10 10:20:00
 * @LastEditors: 陈红伟 chenhw2019@gmail.com
 * @LastEditTime: 2024-01-10 17:57:13
 * @FilePath: /partner.chaoyongtuan.com/src/views/secondColonelManage/productPromotion/list/components/goodsItem.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<div class="flex-row">
			<div class="mt-4">
				<rd-img class="flex-center" imgType="good" :src="row.productPic" :size="68" />
			</div>
			<div class="ml-12">
				<div class="flex-row-align-center">
					<platform-icon style="flex-shrink: 0" :platformId="platformId" />
					<rdText class="ml-4" textType="title">{{ row.outerProductName }}</rdText>
				</div>
				<div class="yx-color-text-regular font-h6-regular">
					<span>ID</span>
					<span class="ml-2">{{ row.outerProductId }}</span>
				</div>
				<div class="yx-color-text-regular font-h6-regular">
					<span>售价</span>
					<span class="ml-2">{{ row.salePrice | formatEmpty | formatPrice2 | formatPrice }}</span>
					<span class="ml-12">库存</span>
					<span class="ml-2">{{ row.stockNum || '0' }}</span>
				</div>
				<div class="yx-color-text-regular font-h6-regular">
					<span>服务费率</span>
					<span class="ml-2">{{ row.serviceRate | formatEmpty | formatPercent2 }}</span>
					<span class="ml-12">普通佣金率</span>
					<span class="ml-2">{{ row.commissionRate | formatEmpty | formatPercent2 }}</span>
					<span class="ml-12">达人佣金率</span>
					<span class="ml-2">{{ row.outerServiceRate | formatEmpty | formatPercent2 }}</span>
				</div>
				<div class="yx-color-text-regular font-h6-regular">
					<span>店铺</span>
					<span class="ml-2">{{ row.shopName | formatEmpty }}</span>
					<span class="ml-12">推广截止时间</span>
					<span class="ml-2">{{ row.promotionEndTime | formatEmpty }}</span>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	components: {},
	props: {
		row: {
			type: Object,
			default: () => {},
		},
		platformId: {
			type: [String, Number],
			default: +dataMap.PLATFORM_DY.value,
		},
	},
	data() {
		return {};
	},
};
</script>
<style lang="less" scoped></style>
